import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html'
})
export class TermsAndConditionsComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    	/* window.scrollTo(0,0); */
    }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/additional-pages/terms-and-conditions/terms-and-conditions.component.ts